import React from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { getGetSingleConditionValue } from '../../../_helpers/singleConditionValue'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import PlaceSelect from '../../../../../../containers/places/select/PlaceSelect'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'
import { useRawInterpolations } from '../../../../../../utils/interpolations/rawInterpolations'

const UpdateAssetSentence = () => {
  const [open, setOpen] = React.useState()
  const { form } = useFormState()
  const checklistId = getGetSingleConditionValue(form.conditions, 'checklist_id')
  const rawInterpolations = useRawInterpolations(form.entity, checklistId)
  const sentenceName = form?.payload?.place ? form?.payload?.place?.name : '_______'

  return (
    <>
      <Text size="h2">de</Text>
      <EditableSentence label={sentenceName} truncate={20} onClick={() => setOpen(true)} field="payload" />

      <Modal open={open} onClose={() => setOpen(false)} width="42rem">
        <Grid paddingGutter={0.5} wrap>
          <Col width="100%">
            <FormItem
              label="Local/Pessoa*"
              path={['payload', 'place']}
              Input={PlaceSelect}
              interpolations={rawInterpolations}
              required
            />
          </Col>
        </Grid>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default UpdateAssetSentence
